import { keys, reduce, isNil, isEmpty } from 'lodash';
import { Helpers, Validations } from '@utils/helpers';
import { IError } from '@utils/useForm';
import { PaymentForm } from '@models/MLTC/Payment.model';

export const validate = (values: PaymentForm) => {
  const fields = keys(values);
  const errors: any = reduce(fields, (result, field: string) => {
    return { ...result, [field]: validateField(values, field) };
  }, {});
  return errors;
}

export const validateField = (values: any, name: string) => {
  console.log(
    'QnB ➤ InitialPremiumForm() ➤ validateField',
    {
      values,
      name
    }
  );
  const value = values[name];
  let error: IError | undefined = { isValid: true };
  switch (name) {
    case 'cpfMediSaveAmount':
      if (isNil(value)) {
        error = { isValid: false };
      } else {
        console.log('QnB ➤ InitialPremiumForm() ➤ cpfMediSaveAmount', { value, isEmpty: isEmpty(String(value)) });

        if (isEmpty(String(value))) {
          error = { isValid: false, message: 'This field can not be empty!' };
        } else {
          const min = 0, max = 600;
          const isOutOfAssured = Validations.isInRange(Number(value), 0, 600);
          if (isOutOfAssured !== 0) {
            error = { isValid: false, message: `Please enter Sum Assured from ${Helpers.toCurrencyND(min)} to ${Helpers.toCurrencyND(max)}` }
          }
        }
      }
      break;
    case 'creditCardAmount':
      break;
  }
  return error;
}